/**
 * 97 chapter Korean names + section grouping (씨엘HS 속견표 미러).
 * Phase 1 static data — 백엔드 호출 없이 즉시 렌더.
 * Note: 77류 는 HS 분류에 존재하지 않음 (배열에서 제외).
 */
export const CHAPTERS_97 = [
  { ch: "01", name: "산 동물" },
  { ch: "02", name: "육과 식용 설육" },
  { ch: "03", name: "어류" },
  { ch: "04", name: "낙농품" },
  { ch: "05", name: "기타 동물성생산품" },
  { ch: "06", name: "산 수목 및 절화" },
  { ch: "07", name: "채소" },
  { ch: "08", name: "과실·견과류" },
  { ch: "09", name: "커피·차·향신료" },
  { ch: "10", name: "곡물" },
  { ch: "11", name: "밀가루·곡분" },
  { ch: "12", name: "채유용 종자·과실" },
  { ch: "13", name: "식물성 액즙" },
  { ch: "14", name: "기타 식물성생산품" },
  { ch: "15", name: "지방과 기름" },
  { ch: "16", name: "육·어류 조제품" },
  { ch: "17", name: "당류·설탕과자" },
  { ch: "18", name: "코코아" },
  { ch: "19", name: "곡물·곡분의 조제품" },
  { ch: "20", name: "채소·과실의 조제품" },
  { ch: "21", name: "조제식료품" },
  { ch: "22", name: "음료·주류" },
  { ch: "23", name: "사료" },
  { ch: "24", name: "담배" },
  { ch: "25", name: "암석광물" },
  { ch: "26", name: "금속광물" },
  { ch: "27", name: "광물성연료" },
  { ch: "28", name: "무기화학품" },
  { ch: "29", name: "유기화학품" },
  { ch: "30", name: "의료용품" },
  { ch: "31", name: "비료" },
  { ch: "32", name: "유연·착색제" },
  { ch: "33", name: "정유·화장품" },
  { ch: "34", name: "비누·왁스" },
  { ch: "35", name: "단백질·전분" },
  { ch: "36", name: "화약류·성냥" },
  { ch: "37", name: "사진용·영화용 재료" },
  { ch: "38", name: "각종 화학공업 생산품" },
  { ch: "39", name: "플라스틱" },
  { ch: "40", name: "고무" },
  { ch: "41", name: "원피·가죽" },
  { ch: "42", name: "가죽제품" },
  { ch: "43", name: "모피·인조모피" },
  { ch: "44", name: "목재" },
  { ch: "45", name: "코르크" },
  { ch: "46", name: "조물 재료의 제품" },
  { ch: "47", name: "펄프" },
  { ch: "48", name: "종이와 판지" },
  { ch: "49", name: "인쇄서적·신문" },
  { ch: "50", name: "견" },
  { ch: "51", name: "양모·동물의 부드러운 털" },
  { ch: "52", name: "면" },
  { ch: "53", name: "그 밖의 식물성 방직용 섬유" },
  { ch: "54", name: "인조필라멘트" },
  { ch: "55", name: "인조스테이플" },
  { ch: "56", name: "워딩·부직포" },
  { ch: "57", name: "양탄자" },
  { ch: "58", name: "특수직물" },
  { ch: "59", name: "도포직물" },
  { ch: "60", name: "편물" },
  { ch: "61", name: "편물제 의류" },
  { ch: "62", name: "비편물제 의류" },
  { ch: "63", name: "기타섬유제품" },
  { ch: "64", name: "신발" },
  { ch: "65", name: "모자" },
  { ch: "66", name: "우산·지팡이" },
  { ch: "67", name: "우모·인모제품" },
  { ch: "68", name: "석·시멘트" },
  { ch: "69", name: "도자제품" },
  { ch: "70", name: "유리" },
  { ch: "71", name: "천연진주·귀석" },
  { ch: "72", name: "철강" },
  { ch: "73", name: "철강의 제품" },
  { ch: "74", name: "구리와 그 제품" },
  { ch: "75", name: "니켈과 그 제품" },
  { ch: "76", name: "알루미늄과 그 제품" },
  { ch: "78", name: "납과 그 제품" },
  { ch: "79", name: "아연과 그 제품" },
  { ch: "80", name: "주석과 그 제품" },
  { ch: "81", name: "그 밖의 비금속" },
  { ch: "82", name: "비금속제 공구·도구·칼붙이" },
  { ch: "83", name: "비금속제 각종 제품" },
  { ch: "84", name: "원자로·보일러·기계류" },
  { ch: "85", name: "전기기기" },
  { ch: "86", name: "철도용 차량" },
  { ch: "87", name: "차량과 그 부분품" },
  { ch: "88", name: "항공기와 우주선" },
  { ch: "89", name: "선박과 수상 구조물" },
  { ch: "90", name: "광학기기·정밀기기" },
  { ch: "91", name: "시계와 부분품" },
  { ch: "92", name: "악기" },
  { ch: "93", name: "무기·총포탄" },
  { ch: "94", name: "가구·침구" },
  { ch: "95", name: "완구·게임용구·운동용구" },
  { ch: "96", name: "잡품" },
  { ch: "97", name: "예술품·골동품" },
];

export const SECTIONS = [
  {
    sec: "1부",
    name: "동물성 생산품",
    chapters: ["01", "02", "03", "04", "05"],
  },
  {
    sec: "2부",
    name: "식물성 생산품",
    chapters: ["06", "07", "08", "09", "10", "11", "12", "13", "14"],
  },
  { sec: "3부", name: "동식물성 유지", chapters: ["15"] },
  {
    sec: "4부",
    name: "조제식료품",
    chapters: ["16", "17", "18", "19", "20", "21", "22", "23", "24"],
  },
  { sec: "5부", name: "광물성 생산품", chapters: ["25", "26", "27"] },
  {
    sec: "6부",
    name: "화학공업생산품",
    chapters: [
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
    ],
  },
  { sec: "7부", name: "플라스틱과 고무", chapters: ["39", "40"] },
  { sec: "8부", name: "원피·가죽·모피", chapters: ["41", "42", "43"] },
  { sec: "9부", name: "목재와 그 제품", chapters: ["44", "45", "46"] },
  { sec: "10부", name: "펄프·종이·인쇄서적", chapters: ["47", "48", "49"] },
  {
    sec: "11부",
    name: "방직용 섬유와 의류",
    chapters: [
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
      "60",
      "61",
      "62",
      "63",
    ],
  },
  {
    sec: "12부",
    name: "신발·모자·우산·가발",
    chapters: ["64", "65", "66", "67"],
  },
  { sec: "13부", name: "석·도자·유리제품", chapters: ["68", "69", "70"] },
  { sec: "14부", name: "진주·귀석·귀금속", chapters: ["71"] },
  {
    sec: "15부",
    name: "비(卑)금속과 그 제품",
    chapters: [
      "72",
      "73",
      "74",
      "75",
      "76",
      "78",
      "79",
      "80",
      "81",
      "82",
      "83",
    ],
  },
  { sec: "16부", name: "기계류·전기기기", chapters: ["84", "85"] },
  { sec: "17부", name: "수송기기", chapters: ["86", "87", "88", "89"] },
  { sec: "18부", name: "광학·측정·의료기기", chapters: ["90", "91", "92"] },
  { sec: "19부", name: "무기", chapters: ["93"] },
  { sec: "20부", name: "잡품", chapters: ["94", "95", "96"] },
  { sec: "21부", name: "예술품·골동품", chapters: ["97"] },
];

// audit 지원 chapter 표시용
export const AUDIT_SUPPORTED = new Set(["33", "42", "39", "64", "61", "62"]);

// 부(部) 배열 원리 — HS(국제통일상품분류)가 류를 21개 부로 묶는 기준(교육용 범례).
export const SECTION_PRINCIPLE =
  "HS(국제통일상품분류)는 97개 류를 21개 부(部)로 묶습니다. 큰 흐름은 " +
  "① 동·식물 1차 산물(1~4부) → ② 광물·화학·플라스틱 등 소재(5~7부) → " +
  "③ 가죽·목재·종이·섬유 등 재료별 제품(8~14부) → ④ 금속·기계·수송·정밀기기 등 공산품(15~18부) → " +
  "⑤ 무기·잡품·예술품(19~21부) 순으로, 대체로 ‘원재료 → 가공 → 완제품’ 및 ‘재질·용도’를 기준으로 배열됩니다. " +
  "속견표의 같은 색(왼쪽 색띠) = 같은 부 = 같은 큰 분류군입니다.";

// 부(部)별 한 줄 설명 — SECTIONS 와 같은 순서(0~20). "공부 안 한 사람도 알 수 있게".
export const SECTION_DESC = [
  "살아있는 동물과 고기·생선·낙농품 등 동물에서 바로 얻는 1차 산물",
  "채소·과실·곡물·종자 등 식물에서 얻는 1차 산물",
  "동물·식물성 기름과 지방, 그 가공품(왁스 등)",
  "가공·조제된 식품과 음료·주류·담배",
  "소금·흙·돌·광석과 광물성 연료(석유·석탄·가스)",
  "무기·유기 화학품, 의약품, 비료, 화장품, 도료 등 화학공업 산물",
  "플라스틱·고무와 그 제품",
  "원피·가죽·모피와 그 제품(가방·핸드백 등)",
  "목재·코르크·짚 등 조물재료와 그 제품",
  "펄프·종이·판지와 인쇄물·서적",
  "견·면·모·인조섬유 등 실·직물과 의류·섬유제품",
  "신발·모자·우산·지팡이·인조꽃·가발 등 신변 용품",
  "돌·시멘트·석면·도자기·유리와 그 제품",
  "천연·양식 진주, 보석, 귀금속과 그 제품",
  "철강·구리·알루미늄 등 비(卑)금속과 그 제품·공구",
  "기계·기계부품과 전기·전자기기",
  "철도·자동차·항공기·선박 등 운송수단",
  "광학·정밀·의료기기, 시계, 악기",
  "무기·총포탄과 그 부분품",
  "가구·완구·운동용구 등 위 분류에 들지 않는 제조품",
  "미술품·수집품·골동품",
];

// 부(部) 류 범위 — "1~5류" / "15류". SECTIONS 순서.
export const SECTION_RANGE = SECTIONS.map((s) => {
  const chs = s.chapters || [];
  if (chs.length === 0) return "";
  const a = parseInt(chs[0], 10);
  const b = parseInt(chs[chs.length - 1], 10);
  return a === b ? `${a}류` : `${a}~${b}류`;
});

// 영문 류명 (WCO HS 표준 chapter title, 간이) — 국문/EN 토글용.
export const CHAPTERS_97_EN = {
  "01": "Live animals",
  "02": "Meat & edible offal",
  "03": "Fish & crustaceans",
  "04": "Dairy; eggs; honey",
  "05": "Animal products nes",
  "06": "Live trees & plants",
  "07": "Edible vegetables",
  "08": "Edible fruit & nuts",
  "09": "Coffee, tea & spices",
  10: "Cereals",
  11: "Milling products",
  12: "Oil seeds & oleaginous fruits",
  13: "Lac; gums & resins",
  14: "Vegetable plaiting materials",
  15: "Animal/vegetable fats & oils",
  16: "Meat/fish preparations",
  17: "Sugars & confectionery",
  18: "Cocoa",
  19: "Cereal/flour preparations",
  20: "Vegetable/fruit preparations",
  21: "Misc edible preparations",
  22: "Beverages, spirits & vinegar",
  23: "Food residues; animal feed",
  24: "Tobacco",
  25: "Salt; sulphur; stone",
  26: "Ores, slag & ash",
  27: "Mineral fuels & oils",
  28: "Inorganic chemicals",
  29: "Organic chemicals",
  30: "Pharmaceutical products",
  31: "Fertilisers",
  32: "Tanning/dyeing extracts; paints",
  33: "Essential oils & cosmetics",
  34: "Soap & waxes",
  35: "Albuminoids; glues; enzymes",
  36: "Explosives; matches",
  37: "Photographic goods",
  38: "Misc chemical products",
  39: "Plastics",
  40: "Rubber",
  41: "Raw hides, skins & leather",
  42: "Articles of leather",
  43: "Furskins & artificial fur",
  44: "Wood & articles of wood",
  45: "Cork",
  46: "Straw/plaiting manufactures",
  47: "Wood pulp",
  48: "Paper & paperboard",
  49: "Printed books & newspapers",
  50: "Silk",
  51: "Wool & animal hair",
  52: "Cotton",
  53: "Other vegetable textile fibres",
  54: "Man-made filaments",
  55: "Man-made staple fibres",
  56: "Wadding, felt & nonwovens",
  57: "Carpets",
  58: "Special woven fabrics",
  59: "Coated/impregnated textiles",
  60: "Knitted/crocheted fabrics",
  61: "Apparel, knitted",
  62: "Apparel, not knitted",
  63: "Other made-up textiles",
  64: "Footwear",
  65: "Headgear",
  66: "Umbrellas & walking sticks",
  67: "Prepared feathers; artificial flowers",
  68: "Articles of stone/cement",
  69: "Ceramic products",
  70: "Glass & glassware",
  71: "Pearls & precious metals",
  72: "Iron & steel",
  73: "Articles of iron or steel",
  74: "Copper",
  75: "Nickel",
  76: "Aluminium",
  78: "Lead",
  79: "Zinc",
  80: "Tin",
  81: "Other base metals",
  82: "Tools & cutlery",
  83: "Misc base metal articles",
  84: "Machinery & mechanical appliances",
  85: "Electrical machinery",
  86: "Railway stock",
  87: "Vehicles (non-railway)",
  88: "Aircraft & spacecraft",
  89: "Ships & boats",
  90: "Optical/measuring/medical instruments",
  91: "Clocks & watches",
  92: "Musical instruments",
  93: "Arms & ammunition",
  94: "Furniture; bedding; lamps",
  95: "Toys, games & sports equipment",
  96: "Misc manufactured articles",
  97: "Works of art & antiques",
};

// 부(部)별 좌측 색띠 팔레트 — 파스텔, cream 배경 위 구분용 (Codex 권고).
export const SECTION_STRIPE = [
  "#a8c5a0",
  "#8fbe8a",
  "#7db87a",
  "#c9a96e",
  "#b0b8c1",
  "#9fb8d8",
  "#8fafc4",
  "#c4a882",
  "#b5a87a",
  "#c8b89a",
  "#a8aeb6",
  "#b4b1b6",
  "#aab4bc",
  "#d4b896",
  "#9daab8",
  "#7898c8",
  "#6888b8",
  "#8898c0",
  "#a8a8b0",
  "#acafb5",
  "#b1b3b8",
];

// chapter → {secName, color} 역방향 맵
const _CH_SEC = {};
SECTIONS.forEach((s, i) => {
  (s.chapters || []).forEach((ch) => {
    _CH_SEC[ch] = {
      secName: `${s.sec} ${s.name}`,
      color: SECTION_STRIPE[i] || "#c8cacd",
    };
  });
});
export const chapterSection = (ch) =>
  _CH_SEC[ch] || { secName: "", color: "#c8cacd" };

// 부(部)별 연한 배경 tint — CLHS식 전체 셀 색조(촘촘한 격자용). stripe 의 라이트 버전.
export const SECTION_TINT = [
  "#eef5ec",
  "#ecf4ea",
  "#eaf3e8",
  "#f5efe2",
  "#eef0f3",
  "#ecf1f8",
  "#eaeff6",
  "#f4eee2",
  "#f1efe2",
  "#f5f1e9",
  "#ecedf0",
  "#f1f0f2",
  "#eef1f3",
  "#f6f0e6",
  "#edf0f4",
  "#e9f0fa",
  "#e7eefa",
  "#ebf0f8",
  "#f0f0f3",
  "#eeeef1",
  "#f0eef0",
];
const _CH_TINT = {};
SECTIONS.forEach((s, i) => {
  (s.chapters || []).forEach((ch) => {
    _CH_TINT[ch] = SECTION_TINT[i] || "#f4f4f2";
  });
});
export const chapterTint = (ch) => _CH_TINT[ch] || "#f4f4f2";
